import { render } from "./Main.vue?vue&type=template&id=04637674&scoped=true"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=04637674&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04637674"

export default script